import { Button, Flex } from "rebass/styled-components";

interface IProps {
  save: () => void,
  close?: () => void,
  isValid: boolean,
  saveBtnCode?: string
}

export const EditModalButtons: React.FC<IProps> = ({ save, close, isValid,saveBtnCode='Save' }) => {
  return (
    <Flex mt={4} flexDirection={'row'} alignItems={'center'} justifyContent={'center'}>
      <Flex flex={1} alignItems={'center'} justifyContent={'center'}>
        {!!close && (
          <Button
            variant={'outline'}
            style={{
              alignSelf: 'center',
              marginRight: '12px',
              width: 'auto',
            }}
            onClick={close}
          >
            Cancel
          </Button>
        )}
        <Button
          variant={'primary'}
          style={{
            alignSelf: 'center',
          }}
          disabled={!isValid}
          onClick={save}
        >
          {saveBtnCode}
        </Button>
      </Flex>
    </Flex>
  );
};